module.exports = __webpack_public_path__ + "static/media/microrredes-abmr-logo.687abb69.png";